import axios from 'axios'
import library from '../../../utils/Library'

export const getSubscriberStatusCorpEntities = async () => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('subscribers') + '/getSubscriberStatusCorpEntities'

  return await axios({
    url: URL,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
